module.exports = __webpack_public_path__ + "img/fruits.1ec2a61d.png";